



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class Header extends Vue {
  private currentRoute: string = '';
  private dark = 'dark';
  private light = 'light';
  private theme = '';

  public mounted() {
    this.theme = localStorage.getItem('theme') || '';
    this.setTheme(this.theme);
  }

  @Watch('$route', { immediate: true, deep: true })
  private onUrlChange(newRoute: Route): void {
    this.currentRoute = newRoute.name || '';
  }

  @Watch('theme')
  private setTheme(value: string) {
    const body = document.querySelector('body') as HTMLBodyElement;

    if (value === this.dark) {
      body.classList.add('theme-dark');
      this.theme = this.dark;
    } else {
      body.classList.remove('theme-dark');
      this.theme = this.light;
    }
    localStorage.setItem('theme', this.theme);
  }

  private async toggleTheme() {
    this.theme = this.theme === this.dark ? this.light : this.dark;
  }
}
